export default __webpack_public_path__ + "static/media/VI.01e14637.svg";